import { render, staticRenderFns } from "./VideoIndex.vue?vue&type=template&id=36066b8e&scoped=true&"
import script from "./VideoIndex.vue?vue&type=script&lang=js&"
export * from "./VideoIndex.vue?vue&type=script&lang=js&"
import style0 from "./VideoIndex.vue?vue&type=style&index=0&id=36066b8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36066b8e",
  null
  
)

export default component.exports